import { render, staticRenderFns } from "./EditEstablishmentPage.vue?vue&type=template&id=6a47708e"
import script from "./EditEstablishmentPage.vue?vue&type=script&lang=js"
export * from "./EditEstablishmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports